import React from 'react';
import './ads info.css'
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBBtn } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import allStrings from "../../assets/strings";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { hasValue } from "../../validations/validations";
import { message, Spin, Image } from "antd";
import Rater from "react-rater";
import "react-rater/lib/react-rater.css";
import 'react-tagsinput/react-tagsinput.css'
import { AdMarketingTable, ButtonsSection, ImageSection, MainCardContent, ModalForDeal, ModalForCancelDeal, ModalForMarket, ModalForRegaData, ModalForSeo, ModalForUpdateStatus, SuggestedClientsTable } from './adsInfoDesign';
import { updateCancelDealApi, getSuggestedClientsApi, deleteApi, sendToRedfApi, marketAdvertisementApi, addSeoDescApi, getAdMarketingApi, getDataApi, getProjectsApi, getUserWithoutPagenationApi, searchForRelatedEmployeeApi, updateStatusApi, makeDealApi, updateRegaDataApi } from './AdsInfoApi';
import axios from 'axios';
import { BASE_END_POINT } from '../../urls'

class adsInfo extends React.Component {
    state = {
        actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
        size: this.props.location.state.data ? this.props.location.state.data.size ? this.props.location.state.data.size : "" : "",
        status: this.props.location.state.data ? this.props.location.state.data.status ? this.props.location.state.data.status : "" : "",
        category: this.props.location.state.data ? this.props.location.state.data.category ? this.props.location.state.data.category.categoryName : null : null,
        categoryType: this.props.location.state.data ? this.props.location.state.data.category ? this.props.location.state.data.category.type : null : null,
        subCategory: this.props.location.state.data ? this.props.location.state.data.subCategory ? this.props.location.state.data.subCategory.categoryName : null : null,
        area: this.props.location.state.data ? this.props.location.state.data.area ? this.props.location.state.data.area.areaName : null : null,
        city: this.props.location.state.data ? this.props.location.state.data.city ? this.props.location.state.data.city.cityName : null : null,
        inMarket: false,
        commissionCost: 0,
        createdAt: null,
        features: [],
        properties: [],
        rate: 0,
        viewsCount: this.props.location.state.data ? this.props.location.state.data.viewsCount ? this.props.location.state.data.viewsCount : 0 : 0,
        id: this.props.location.state.data ? this.props.location.state.data.id : null,
        location: "",
        contractType: "",
        price: this.props.location.state.data ? this.props.location.state.data.price ? this.props.location.state.data.price : 0 : 0,
        priceType: "NORMAL",
        rentType: "MONTHLY",
        owner: this.props.location.state.data ? this.props.location.state.data.owner ? this.props.location.state.data.owner : [] : [],
        paymentPlan: null,
        company: "",

        allImgs: [],
        lands: [],
        units: [],
        villas: [],
        buildings: [],
        bestFeature_en: "",
        bestFeature_ar: "",
        address_ar: "",
        address_en: "",
        enableInstallment: "",
        commissionNumber: "",
        advertiserClass: "",
        deposit: "",
        hasDeposit: "",
        region: null,
        advertisementImgs: [],
        description_en: "",
        description_ar: "",
        title_en: "",
        title_ar: "",
        available: "",
        seoDescription_en: "",
        seoDescription_ar: "",
        seoTitle_en: "",
        seoTitle_ar: "",
        imgs: null,
        imgsType: 'data',
        subCategories: [],
        categories: [],
        areas: [],
        regions: [],
        cities: [],
        marketingAdInfo: [],
        pages: 1,
        page: 1,
        pages2: 1,
        page2: 1,
        isInRedf: false,
        seoTags: [],
        copyColor: '#1D9598',
        modalForSeo: false,
        modalForMarket: false,
        modalForDeal: false,
        client: '',
        contractFile: null,
        contractFileType: 'data',
        contractFileName: '',
        recieptFile: null,
        recieptFileType: 'data',
        recieptFileName: '',
        depositRefundReciept: null,
        depositRefundRecieptName: '',
        depositRefundRecieptType: "data",
        adNumber: '',
        modalForUpdateStatus: false,
        clientPhone: '',
        clientName: '',
        clientType: '',
        clientBirthday: null,
        clientCountry: null,
        clientIdNumber: '',
        paymentType: 'CASH',
        discount: 0,
        depositPayType: 'SAAEI',
        deliveredDate: null,
        completedDate: null,
        updateStatus: null,
        employee: [],
        users: [],
        project: null,
        projects: [],
        suggestedClients: [],
        deal: null,
        soldBy: 'SAAEI',
        countries: [],
        modalForCancelDeal: false,
        refundType: 'OTHER',
        reason: ''
    };
    constructor(props) {
        super(props)
        window.scrollTo(0, 0)
        this.inputRef = React.createRef();
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
        this.getCountries()
        this.getUserWithoutPagenation()
        this.getProjects()
        window.addEventListener('popstate', this.handlePopState);

        let initialAdId = this.state.id;
        const storedAdId = sessionStorage.getItem('currentAdId');

        if (storedAdId && parseInt(storedAdId, 10) !== initialAdId) {
            initialAdId = parseInt(storedAdId, 10);
            this.setState({ id: initialAdId });
            this.getAdsData(initialAdId);
            this.getAdMarketing(1, initialAdId);
            this.getSuggestedClients(1, initialAdId)
        } else {
            this.getAdsData(initialAdId);
            this.getAdMarketing(1, initialAdId);
            this.getSuggestedClients(1, initialAdId)
        }
    }
    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
    }
    handlePopState = (event) => {
        const adIdFromHistory = event.state && event.state.data ? event.state.data.adId : null;
        let targetAdId;

        if (adIdFromHistory) {
            targetAdId = adIdFromHistory;
            sessionStorage.setItem('currentAdId', targetAdId.toString());
        } else {
            targetAdId = this.state.advertisementParent;
            sessionStorage.removeItem('currentAdId');
        }

        if (targetAdId) {
            this.getAdsData(targetAdId);
            this.getAdMarketing(1, targetAdId);
            this.getSuggestedClients(1, targetAdId)
            this.setState({ id: targetAdId });
        } else {
            console.warn('Cannot load Ad data: targetAdId is missing.');
        }
    }
    setNewData = (id) => {
        window.scrollTo(0, 0)
        this.getAdsData(id)
        this.getAdMarketing(1, id)
        this.getSuggestedClients(1, id)
        this.setState({ id: id })
        sessionStorage.setItem('currentAdId', id.toString());
        const newState = {
            adId: id,
            actionType: "VIEW",
        }
        window.history.pushState({ data: newState }, '', window.location.pathname)
    }
    changeHandler = event => {
        console.log("change :", event.target.name)
        this.setState({ [event.target.name]: event.target.value });
        if (event.target.name === "clientPhone" && this.state.project) {
            this.searchForReleatedEmployee(event.target.value, this.state.project)
        }
    };
    handleChangeState = (fieldName, value) => {
        console.log(fieldName, value);
        this.setState({ [fieldName]: value });
        if (fieldName === 'project' && this.state.clientPhone && hasValue(this.state.clientPhone)) {
            this.searchForReleatedEmployee(this.state.clientPhone, value);
        }
    };
    getCountries = () => {
        axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`)
            .then(response => {
                console.log(response.data)
                this.setState({ countries: response.data.data })
            })
            .catch(error => {
                console.log("ALL countries ERROR")
                console.log(error.response)
            })
    }
    getAdsData = async (id) => {
        this.setState({ loading: true });
        try {
            const data = await getDataApi(id, this.props.currentUser.token, this.props.isRTL);
            console.log('theAds ', data);
            const adData = data.data;
            const newState = {
                loading: false,
                adNumber: adData.adNumber,
                size: adData.size,
                status: adData.status,
                area: adData.area ? adData.area.areaName : null,
                city: adData.city ? adData.city.cityName : null,
                id: adData.id,
                location: adData.location ? adData.location : "",
                contractType: adData.contractType,
                price: adData.price,
                priceType: adData.priceType,
                rentType: adData.rentType ? adData.rentType : "MONTHLY",
                owner: adData.owner ? adData.owner : [],
                viewsCount: adData.viewsCount ? adData.viewsCount : 0,
                allImgs: adData.imgs ? adData.imgs : [],
                inMarket: adData.inMarket ? adData.inMarket : false,
                commissionCost: adData.commissionCost ? adData.commissionCost : 0,
                createdAt: adData.createdAt ? adData.createdAt : null,
                available: adData.available ? adData.available : false,
                bestFeature_en: adData.bestFeature_en ? adData.bestFeature_en : "",
                bestFeature_ar: adData.bestFeature_ar ? adData.bestFeature_ar : "",
                address_ar: adData.address_ar ? adData.address_ar : "",
                address_en: adData.address_en ? adData.address_en : "",
                enableInstallment: adData.enableInstallment ? adData.enableInstallment : false,
                commissionNumber: adData.commissionNumber ? adData.commissionNumber : "",
                advertiserClass: adData.advertiserClass ? adData.advertiserClass : "",
                deposit: adData.deposit ? adData.deposit : "",
                depositPaidUser: adData.depositPaidUser ? adData.depositPaidUser : null,
                hasDeposit: adData.hasDeposit ? adData.hasDeposit : "",
                region: adData.region ? adData.region.id : null,
                category: adData.category ? adData.category.categoryName : null,
                categoryType: adData.category ? adData.category.type : null,
                subCategory: adData.subCategory ? adData.subCategory.categoryName : null,
                description_en: adData.description_en ? adData.description_en : "",
                description_ar: adData.description_ar ? adData.description_ar : "",
                title_en: adData.title_en ? adData.title_en : "",
                title_ar: adData.title_ar ? adData.title_ar : "",
                rate: adData.rate ? adData.rate : 0,
                features: adData.features ? adData.features : [],
                properties: adData.properties ? adData.properties : [],
                lands: adData.lands ? adData.lands : [],
                villas: adData.villas ? adData.villas : [],
                buildings: adData.buildings ? adData.buildings : [],
                units: adData.units ? adData.units : [],
                seoDescription_en: adData.seoDescription_en ? adData.seoDescription_en : "",
                seoDescription_ar: adData.seoDescription_ar ? adData.seoDescription_ar : "",
                seoTitle_en: adData.seoTitle_en ? adData.seoTitle_en : "",
                seoTitle_ar: adData.seoTitle_ar ? adData.seoTitle_ar : "",
                seoTags: adData.seoTags ? adData.seoTags : [],
                isInRedf: adData.isInRedf,
                paymentPlan: adData.paymentPlan,
                company: adData.company ? adData.company.name : 'ساعى',
                updateStatus: null,
                employee: [],
                advertisementParent: adData.advertisementParent ? adData.advertisementParent : null,
                deal: adData.deal ? adData.deal : null,
                project: adData.project ? adData.project : null,
            };
            this.setState(newState);

            if (adData.imgs && adData.imgs.length > 0) {
                let i = adData.imgs.map(img => ({ original: img, thumbnail: img }));
                this.setState({ advertisementImgs: i });
                window.scrollTo(0, 0);
            }
        } catch (error) {
            console.log('add ERROR ', error);
            this.setState({ loading: false });
        }
    };

    getAdMarketing = async (page, id) => {
        try {
            const data = await getAdMarketingApi(page, id, this.props.currentUser.token, this.props.isRTL);
            console.log('marketingAdInfo ', data);
            this.setState({
                marketingAdInfo: data.data,
                pages: data.pageCount,
                page: data.page,
                loading: false,
            });
        } catch (error) {
            console.log('marketingAdInfo ERROR ', error);
        }
    };
    getSuggestedClients = async (page, id) => {
        try {
            const data = await getSuggestedClientsApi(page, id, this.props.currentUser.token, this.props.isRTL);
            console.log('getSuggestedClients ', data);
            this.setState({
                suggestedClients: data.data,
                pages2: data.pageCount,
                page2: data.page,
                loading: false,
            });
        } catch (error) {
            console.log('marketingAdInfo ERROR ', error);
        }
    };
    getProjects = async () => {
        try {
            const data = await getProjectsApi();
            this.setState({ projects: data.data });
        } catch (error) {
            console.log("ALL projects ERROR");
            console.log(error.response);
        }
    };
    searchForReleatedEmployee = async (clientPhone, project) => {
        try {
            const data = await searchForRelatedEmployeeApi(clientPhone, project, this.props.currentUser.token, this.props.isRTL);
            console.log(data);
            this.setState({ employee: data.employee ? [data.employee] : [] });
        } catch (error) {
            console.log(" employee ERROR");
            console.log(error.response);
            this.setState({ employee: [] });
        }
    };
    delete = async () => {
        try {
            await deleteApi(this.props.location.state.data.id, this.props.currentUser.token, this.props.isRTL, allStrings);
            console.log("ads DELETED");
            this.props.history.goBack();
        } catch (error) {
            console.log(error);
        }
    };
    sendToRedf = async () => {
        try {
            await sendToRedfApi(this.props.location.state.data.id, this.props.currentUser.token, this.props.isRTL, allStrings);
            this.props.history.goBack();
        } catch (error) {
            console.log(error);
        }
    };
    marketAdvertisement = async (inMarket) => {
        try {
            await marketAdvertisementApi(this.state.id, inMarket, this.state.commissionCost, this.props.currentUser.token, allStrings);
            if (inMarket) {
                this.toggleMarket();
                this.setState({ inMarket: true });
            } else {
                this.setState({ inMarket: false });
            }
        } catch (error) {
            console.log('Error ', error);
        }
    };
    addSeoDesc = async () => {
        const { seoDescription_en, seoDescription_ar, seoTitle_ar, seoTitle_en, seoTags, bestFeature_en, bestFeature_ar, id } = this.state;
        if (hasValue(seoDescription_en) && hasValue(seoDescription_ar)) {
            const seoData = {
                'seoDescription_en': seoDescription_en,
                'seoDescription_ar': seoDescription_ar,
                'seoTitle_en': seoTitle_en,
                'seoTitle_ar': seoTitle_ar,
                'seoTags': seoTags,
                'bestFeature_en': bestFeature_en,
                'bestFeature_ar': bestFeature_ar,
            };
            try {
                await addSeoDescApi(id, seoData, this.props.currentUser.token, this.props.isRTL, allStrings);
                this.toggleAddSeo();
                this.props.history.goBack();
            } catch (error) {
                console.log(error);
            }
        }
    };
    getUserWithoutPagenation = async () => {
        try {
            const data = await getUserWithoutPagenationApi(this.props.currentUser.token, this.props.isRTL);
            console.log("users:", data.data);
            this.setState({ users: data.data });
        } catch (error) {
            console.log("ALL users ERROR");
            console.log(error.response);
        }
    };
    updateStatus = async () => {
        const { updateStatus, clientPhone, clientName, clientBirthday, clientCountry, clientType, clientIdNumber, discount, paymentType, soldBy, deposit,
            depositPayType, recieptFile, deliveredDate, completedDate, employee, id, depositRefundReciept } = this.state;
        if (hasValue(updateStatus)) {
            try {
                let data = new FormData();
                data.append('status', updateStatus);
                if (employee) data.append('employee', JSON.stringify(employee));
                if (clientType) data.append('clientType', clientType);
                if (clientName) data.append('clientName', clientName);
                if (clientPhone) data.append('clientPhone', clientPhone);
                if (clientBirthday) data.append('clientBirthday', clientBirthday);
                if (clientCountry) data.append('clientCountry', clientCountry);
                if (clientIdNumber) data.append('clientIdNumber', clientIdNumber);
                if (paymentType) data.append('paymentType', paymentType);
                if (discount) data.append('discount', discount);
                if (depositPayType) data.append('depositPayType', depositPayType);
                if (deliveredDate) data.append('deliveredDate', deliveredDate);
                if (completedDate) data.append('completedDate', completedDate);
                if (recieptFile) data.append('recieptFile', recieptFile);
                if (depositRefundReciept) data.append('depositRefundReciept', depositRefundReciept)
                if (soldBy) data.append('soldBy', soldBy)
                if (deposit) data.append('deposit', deposit)
                let response = await updateStatusApi(id, data, this.props.currentUser.token, this.props.isRTL, allStrings);
                if (response.success) {
                    this.toggleForUpdateStatus();
                    this.props.history.goBack();
                }

            } catch (error) {
                console.log(error);
            }
        }
    };
    cancelDeal = async () => {
        const { id, refundType, reason, depositRefundReciept } = this.state;
        if (hasValue(refundType) && hasValue(reason)) {
            try {
                let data = new FormData();
                data.append('refundType', refundType);
                data.append('reason', reason);
                data.append('depositRefundReciept', depositRefundReciept)
                let response = await updateCancelDealApi(id, data, this.props.currentUser.token, this.props.isRTL, allStrings);
                if (response.success) {
                    this.toggleForCancelDeal();
                    this.props.history.goBack()
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
    makeDeal = async () => {
        const { client, contractFile, recieptFile, id } = this.state;
        if (hasValue(client)) {
            try {
                let data = new FormData()
                data.append('advertisement', this.state.id)
                data.append('client', client)
                if (contractFile != null) {
                    data.append(`contractFile`, contractFile)
                }
                if (recieptFile != null) {
                    data.append(`recieptFile`, recieptFile)
                }
                let response = await makeDealApi(id, data, this.props.currentUser.token, this.props.isRTL, allStrings);
                if (response.success) {
                    this.toggleForDeal()
                    this.props.history.goBack()
                }
            } catch (error) {
                console.log(error);
            }
        }
    };
    updateRegaData = async () => {
        const { adNumber, id } = this.state;
        if (hasValue(adNumber)) {
            try {
                const data = {
                    "idType": "2",
                    "idNumber": "7023182087",
                    'adNumber': adNumber
                }
                console.log(data)
                let response = await updateRegaDataApi(id, data, this.props.currentUser.token, this.props.isRTL, allStrings);
                if (response.success) {
                    this.toggleForRegaData()
                    this.props.history.goBack()
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    //add to market
    submitHandlerAddInMarket = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.marketAdvertisement(true)
    };
    toggleMarket = () => {
        this.setState({
            modalForMarket: !this.state.modalForMarket,
        });
    }
    //add seo desc
    submitHandlerAddSeoDesc = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.addSeoDesc()
    };
    toggleAddSeo = () => {
        this.setState({
            modalForSeo: !this.state.modalForSeo,
        });
    }
    handleTagsChange = (tags) => {
        this.setState({ seoTags: tags })
    }
    //make deal
    submitHandlerDeal = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.makeDeal()
    };
    toggleForDeal = () => {
        this.setState({
            modalForDeal: !this.state.modalForDeal,
        });
    }
    //make Cancel Deal
    submitHandlerCancelDeal = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.cancelDeal()
    };
    toggleForCancelDeal = () => {
        this.setState({
            modalForCancelDeal: !this.state.modalForCancelDeal,
        });
    }
    //update rega data
    submitHandleUpdateRegaData = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.updateRegaData()
    };
    toggleForRegaData = () => {
        this.setState({
            modalForRegaData: !this.state.modalForRegaData,
        });
    }
    //update status
    submitHandleUpdateStatus = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.updateStatus()
    };
    toggleForUpdateStatus = () => {
        this.setState({
            modalForUpdateStatus: !this.state.modalForUpdateStatus,
        });
    }

    fileChangedHandlerContractFile = event => {
        this.setState({
            contractFile: event.target.files[0],
            contractFileName: event.target.files[0].name,
            contractFileType: "data"
        })
    }
    removeContractFile = () => {
        this.setState({
            contractFile: null,
            contractFileName: '',
            contractFileType: "url"
        });
    }
    fileChangedHandlerRecieptFile = event => {
        this.setState({
            recieptFile: event.target.files[0],
            recieptFileName: event.target.files[0].name,
            recieptFileType: "data"
        })
    }
    removeRecieptFile = () => {
        this.setState({
            recieptFile: null,
            recieptFileName: '',
            recieptFileType: "url"
        });
    }
    fileChangedHandlerDepositRefundReciept = event => {
        console.log(event.target.files[0])
        this.setState({
            depositRefundReciept: event.target.files[0],
            depositRefundRecieptName: event.target.files[0].name,
            depositRefundRecieptType: "data"
        })
    }
    removeDepositRefundReciept = () => {
        this.setState({
            depositRefundReciept: null,
            depositRefundRecieptName: '',
            depositRefundRecieptType: "url"
        });
    }
    render() {
        if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('ADS')) return <Redirect to='/Home' />
        return (
            <div className="App">
                <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{ color: '#1D9598' }}>
                    <ModalForMarket
                        isOpen={this.state.modalForMarket}
                        toggleMarket={this.toggleMarket}
                        submitHandlerAddInMarket={this.submitHandlerAddInMarket}
                        changeHandler={this.changeHandler}
                        isRTL={this.props.isRTL}
                        allStrings={allStrings}
                    />

                    <ModalForSeo
                        isOpen={this.state.modalForSeo}
                        toggleAddSeo={this.toggleAddSeo}
                        submitHandlerAddSeoDesc={this.submitHandlerAddSeoDesc}
                        changeHandler={this.changeHandler}
                        handleTagsChange={this.handleTagsChange}
                        state={this.state}
                        isRTL={this.props.isRTL}
                        allStrings={allStrings}
                    />

                    <ModalForDeal
                        isOpen={this.state.modalForDeal}
                        toggleForDeal={this.toggleForDeal}
                        submitHandlerDeal={this.submitHandlerDeal}
                        changeHandler={this.changeHandler}
                        fileChangedHandlerContractFile={this.fileChangedHandlerContractFile}
                        fileChangedHandlerRecieptFile={this.fileChangedHandlerRecieptFile}
                        removeContractFile={this.removeContractFile}
                        removeRecieptFile={this.removeRecieptFile}
                        state={this.state}
                        isRTL={this.props.isRTL}
                        allStrings={allStrings}
                    />
                    <ModalForCancelDeal
                        isOpen={this.state.modalForCancelDeal}
                        toggleForCancelDeal={this.toggleForCancelDeal}
                        submitHandlerCancelDeal={this.submitHandlerCancelDeal}
                        changeHandler={this.changeHandler}
                        handleChangeState={this.handleChangeState}
                        fileChangedHandlerDepositRefundReciept={this.fileChangedHandlerDepositRefundReciept}
                        removeDepositRefundReciept={this.removeDepositRefundReciept}
                        state={this.state}
                        isRTL={this.props.isRTL}
                        allStrings={allStrings}
                    />

                    <ModalForRegaData
                        isOpen={this.state.modalForRegaData}
                        toggleForRegaData={this.toggleForRegaData}
                        submitHandleUpdateRegaData={this.submitHandleUpdateRegaData}
                        changeHandler={this.changeHandler}
                        state={this.state}
                        isRTL={this.props.isRTL}
                        allStrings={allStrings}
                    />

                    <ModalForUpdateStatus
                        isOpen={this.state.modalForUpdateStatus}
                        currentUser={this.props.currentUser}
                        toggleForUpdateStatus={this.toggleForUpdateStatus}
                        submitHandleUpdateStatus={this.submitHandleUpdateStatus}
                        changeHandler={this.changeHandler}
                        fileChangedHandlerRecieptFile={this.fileChangedHandlerRecieptFile}
                        removeRecieptFile={this.removeRecieptFile}
                        searchForReleatedEmployee={this.searchForReleatedEmployee}
                        state={this.state}
                        isRTL={this.props.isRTL}
                        allStrings={allStrings}
                        handleChangeState={this.handleChangeState}
                        fileChangedHandlerDepositRefundReciept={this.fileChangedHandlerDepositRefundReciept}
                        removeDepositRefundReciept={this.removeDepositRefundReciept}

                    />

                    <MDBContainer>
                        {this.state.actionType === "VIEW" &&
                            <MDBRow style={{ flexFlow: this.props.isRTL ? 'row-reverse' : 'row' }} >
                                <MDBCol md='12'>
                                    <MDBBtn onClick={() => { this.delete() }} rounded style={{ display: 'inline-block', width: 'fit-content', margin: '8px', background: 'linear-gradient(135deg, #FF3547, #B71C1C)', color: '#fff', borderRadius: '10px' }} color="FF3547" className="btn-block z-depth-1a">
                                        <MDBIcon icon="trash-alt" className="mr-2" />
                                        {allStrings.remove}
                                    </MDBBtn>
                                    {(this.props.currentUser.user.type === "ADMIN" ||
                                        (this.props.currentUser.user.type === "SUB-ADMIN" && this.props.currentUser.user.managingProjects.includes(this.state.project)) ||
                                        (this.props.currentUser.user.type === "SUB-ADMIN" && this.props.currentUser.user.isEmployee)
                                    ) && (
                                            <MDBBtn
                                                onClick={this.toggleForUpdateStatus}
                                                color="none"
                                                style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }} rounded
                                                className="btn-block z-depth-1a"
                                            >
                                                {allStrings.updateStatus}
                                            </MDBBtn>
                                        )}
                                    {(this.state.deal && this.props.currentUser.user.type === "ADMIN" ||
                                        (this.state.deal && this.props.currentUser.user.type === "SUB-ADMIN" && this.props.currentUser.user.managingProjects.includes(this.state.project)) ||
                                        (this.state.deal && this.props.currentUser.user.type === "SUB-ADMIN" && this.props.currentUser.user.isEmployee)
                                    ) && (
                                            <MDBBtn
                                                color="none"
                                                onClick={this.toggleForCancelDeal}
                                                style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                                                rounded
                                                className="btn-block z-depth-1a"
                                            >
                                                {allStrings.cancelDeal}
                                            </MDBBtn>
                                        )}
                                    <MDBBtn
                                        onClick={this.toggleAddSeo}
                                        color="none"
                                        style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }} rounded
                                        className="btn-block z-depth-1a"
                                    >
                                        <MDBIcon icon="plus" className="mr-2" />
                                        {allStrings.addSeoDesc}
                                    </MDBBtn>
                                    <MDBBtn
                                        onClick={this.toggleForRegaData}
                                        color="none"
                                        style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }} rounded
                                        className="btn-block z-depth-1a"
                                    >
                                        {allStrings.updateRegaData}
                                    </MDBBtn>
                                    <MDBBtn
                                        color="none"
                                        style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                                        onClick={() => { this.props.history.push("views", { adveristment: this.state.id }) }}
                                        rounded
                                        className="btn-block z-depth-1a"
                                    >
                                        {allStrings.views}
                                    </MDBBtn>
                                    {!this.state.isInRedf &&
                                        <MDBBtn
                                            onClick={this.sendToRedf}
                                            color="none"
                                            style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }} rounded
                                            className="btn-block z-depth-1a"
                                        >
                                            {allStrings.sendToRedf}
                                        </MDBBtn>
                                    }
                                    {this.state.inMarket ?
                                        <MDBBtn
                                            rounded
                                            color="none"
                                            style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                                            className="btn-block z-depth-1a"
                                            onClick={() => { this.marketAdvertisement(false) }}
                                        >
                                            <MDBIcon icon="ban" className="mr-2" />
                                            {allStrings.removeFromMarket}
                                        </MDBBtn>
                                        :
                                        <MDBBtn
                                            rounded
                                            color="none"
                                            style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                                            className="btn-block z-depth-1a"
                                            onClick={() => { this.toggleMarket() }}
                                        >
                                            <MDBIcon icon="check-circle" className="mr-2" />
                                            {allStrings.addInMarket}
                                        </MDBBtn>
                                    }
                                </MDBCol>
                            </MDBRow>
                        }
                        <MDBRow style={{ flexFlow: this.props.isRTL ? 'row-reverse' : 'row' }} >
                            <MDBCol xl="12" lg="12" md="12" sm="12">
                                <div className="infoCard">
                                    <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                                        <CardMedia
                                            style={{ height: "0px" }}
                                        />
                                        <CardHeader></CardHeader>
                                        <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                                            {this.state.actionType === "VIEW" ?
                                                <div className="topIcon" style={{ padding: '0px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <ImageSection
                                                        advertisementImgs={this.state.advertisementImgs}
                                                    />
                                                </div>
                                                :
                                                <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                                                    <span className="material-icons" style={{ color: 'white', fontSize: 20 }}>featured_video</span>
                                                </div>
                                            }
                                            <div className="tableTitle" style={{
                                                display: 'inline-block', marginTop: '-60px',
                                                marginLeft: '0', marginRight: '0'
                                            }}>
                                                <p>{allStrings.theAdd}</p>
                                            </div>
                                        </div>
                                        <div style={{ width: '100%', display: 'none' }}>
                                            <Rater style={{ float: this.props.isRTL ? 'left' : 'right', marginRight: '20px', marginLeft: '20px' }} rating={this.state.rate} total={5} interactive={false} />
                                        </div>
                                        <MainCardContent
                                            state={this.state}
                                            isRTL={this.props.isRTL}
                                            allStrings={allStrings}
                                            history={this.props.history}
                                            setNewData={this.setNewData}
                                        />
                                    </Card>
                                </div>
                            </MDBCol>
                        </MDBRow>
                        {this.state.actionType === "VIEW" && this.state.categoryType !== "PLANNED" &&
                            this.state.categoryType !== "VILLAS" && this.state.categoryType !== "BUILDING" &&
                            this.state.categoryType !== "OFF-PLAN-SALE" &&
                            <SuggestedClientsTable
                                allStrings={allStrings}
                                state={this.state}
                                isRTL={this.props.isRTL}
                                history={this.props.history}
                                getSuggestedClients={this.getSuggestedClients}
                                setPage={(page) => this.setState({ page2: page })}
                            />
                        }
                        {this.state.actionType === "VIEW" &&
                            <AdMarketingTable
                                allStrings={allStrings}
                                state={this.state}
                                isRTL={this.props.isRTL}
                                history={this.props.history}
                                getAdMarketing={this.getAdMarketing}
                                setPage={(page) => this.setState({ pagea: page })}
                            />
                        }

                    </MDBContainer>
                </Spin>
            </div>
        )
    }
}
const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});
const mapDispatchToProps = {
};
export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(adsInfo)
);